import { formatType, getCategoryLabel } from '@/lib/categories'
import { ArrowRightIcon } from '@phosphor-icons/react'
import { Link } from 'react-router-dom'

import type { PublicHelpArticleSummary } from '@scrambl/shared/types/help-site'

export function ArticleList({
  articles,
  showCategory = false,
}: {
  articles: PublicHelpArticleSummary[]
  showCategory?: boolean
}) {
  return (
    <ul className="article-list">
      {articles.map(article => (
        <li key={article.id}>
          <Link
            to={`/articles/${encodeURIComponent(article.id)}`}
            className="article-row"
          >
            <div className="article-row-text">
              <span className="article-row-title">{article.title}</span>
              <span className="article-row-summary">{article.summary}</span>
            </div>
            <span className="article-row-meta">
              {showCategory ? (
                <span className="article-row-category">
                  {getCategoryLabel(article.moduleSlug)}
                </span>
              ) : null}
              <span className={`type-chip type-${article.type}`}>
                {formatType(article.type)}
              </span>
              <ArrowRightIcon size={14} className="article-row-arrow" />
            </span>
          </Link>
        </li>
      ))}
    </ul>
  )
}
